// (function () {
//     const pathSegments = window.location.pathname.split('/').filter(Boolean);
//     if(pathSegments[0]=="apps" && pathSegments[1]=="levis-custom-api" && pathSegments[2]=="staff-snap" && pathSegments[3]=="details"){
//         window.location.replace(`/pages/snap/${pathSegments[4]}`);
//     }
//     if(pathSegments[0]=="apps" && pathSegments[1]=="levis-custom-api" && pathSegments[2]=="staff-snap" && pathSegments[3]=="staff"){
//                 window.location.replace(`/pages/staff/${pathSegments[4]}`);
//     }
//     if (window.location.pathname === '/apps/levis-custom-api/staff-snap/search') {
//             window.location.replace('/pages/staff-snap-search');
//     }
// })();
document.addEventListener('DOMContentLoaded', function() {
    const appProxy = window.levis_api_app_proxy;
    const staffStartApiUrl = window.staff_start_api_url;
    const staffStartMerchantId = window.staff_start_merchant_id;
    const staffStartFavoritedSnaps = window.staff_start_favorited_snaps;
    const staffStartFollowingStaffs = window.staff_start_following_staffs;
    const loggedIn = window.logged_in === 'true';

    let isFollowing = false;

    const heartBeadAnimation = (target) => {
        target.classList.add('heart-beat');
        setTimeout(() => {
            target.classList.remove('heart-beat');
        }, 1000);
    }

    async function followButtonClick(event) {
        event.preventDefault();
        const snapId = event.target.getAttribute('data-cid');
        const isFavorited = event.target.classList.contains('active');

        heartBeadAnimation(event.target);

        try {
            if (loggedIn) {
                const response = await fetch(isFavorited ? `${appProxy}/staff-start/api/favorite-snaps/${snapId}` : `${appProxy}/staff-start/api/favorite-snaps`, {
                    method: isFavorited ? 'DELETE' : 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: isFavorited ? null : JSON.stringify({ snapId })
                });
                if (response.status === 401) {
                    window.location.href = '/account/login';
                    return;
                }
                const result = await response.json();
                if (result.success) {
                    event.target.classList.toggle('active');
                }
            } else {
                window.location.href = '/account/login';
                return;
            }
        } catch (error) {
            console.error('Error:', error);
        }
    }

    function updateFollowButton() {
        const followIcon = document.querySelector('.follow-icon');
        const followText = document.querySelector('.follow-text');
        if (isFollowing) {
            followIcon.classList.add('active');
            followText.textContent = 'フォロー中....';
        } else {
            followIcon.classList.remove('active');
            followText.textContent = 'フォローする';
        }
    }

    async function fetchFavorites() {
        try {
            favoritedSnaps = JSON.parse(staffStartFavoritedSnaps);
            updateFavoriteButtons();
        } catch (error) {
            console.error('Error fetching favorite snaps:', error);
        }
    }

    async function fetchFollowStatus(staffId) {
        try {
            const followingStaffs = JSON.parse(staffStartFollowingStaffs);
            isFollowing = followingStaffs.includes(staffId);
            updateFollowButton();
        } catch (error) {
            console.error('Error fetching follow status:', error);
        }
    }

    function updateFavoriteButtons() {
        const followButtons = document.querySelectorAll('.follow-btn');
        followButtons.forEach(button => {
            const snapId = button.getAttribute('data-cid');
            if (favoritedSnaps && favoritedSnaps.includes(snapId)) {
                button.classList.add('active');
            }
        });
    }

    if (window.location.pathname === '/') {
        const staffSnapContainer = document.getElementsByClassName('staff-snap__container')[0];
        if (staffSnapContainer) {
            let parentElement = staffSnapContainer.closest('.page-width');
            if (parentElement) {
                parentElement.classList.add('page-width-desktop');
            }
        }
    }
    if (window.location.href.includes('staff-snap/staff/')) {
        const snapsContainer = document.getElementById('snaps-container');
        const paginationControls = document.getElementById('pagination-controls');
        const staffId = document.getElementById('staff-id').dataset.staffId;

        const itemsPerPage = 40;
        let currentPage = 1;
        let favoritedSnaps = [];

        if (loggedIn) {
            fetchFollowStatus(staffId);
        }

        document.body.addEventListener('click', async function(event) {
            if (event.target.classList.contains('follow-btn')) {
                followButtonClick(event);
            } else if (event.target.classList.contains('follow-icon') || event.target.classList.contains('follow-text')) {
                event.preventDefault();
                heartBeadAnimation(event.target);
                try {
                    const response = await fetch(isFollowing ? `${appProxy}/staff-start/api/follow-staffs/${staffId}` : `${appProxy}/staff-start/api/follow-staffs`, {
                        method: isFollowing ? 'DELETE' : 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: isFollowing ? null : JSON.stringify({ staffId: staffId })
                    });
                    if (response.status === 401) {
                        window.location.href = '/account/login';
                        return;
                    }
                    const result = await response.json();
                    console.log("ResultDATAA", result)
                    if (result.success) {
                        isFollowing = !isFollowing;
                        updateFollowButton();
                    } else {
                        console.log(result);
                    }
                } catch (error) {
                    console.error('Error:', error);
                }
            }
        });

        async function renderPage(page) {
            try {
                if (loggedIn) {
                    favoritedSnaps = JSON.parse(staffStartFavoritedSnaps);
                }

                const queryString = new URLSearchParams({
                    merchant_id: staffStartMerchantId,
                    user_id: staffId,
                    offset: (page - 1) * itemsPerPage,
                    count: itemsPerPage
                });
                showLoader();
                const response = await fetch(`${staffStartApiUrl}/v1/coordinate?${queryString}`);
                const data = await response.json();
                hideLoader();

                snapsContainer.innerHTML = '';

                data.item.forEach(snap => {
                    //const prodtitles = snap.products.map(p => p.name).join(" + ");
                     const prodtitles = snap.products?.map(p => p.name).join(' + ') || '';
                    const snapElement = document.createElement('div');
                    snapElement.classList.add('staff-snap__snap');
                    snapElement.innerHTML = `
                        <a href="/apps/levis-custom-api/staff-snap/details/${snap.cid}">
                            <img src="${snap.image_url}" alt="${snap.user_name} + ${prodtitles}">
                        </a>
                        <a href="#" data-cid="${snap.cid}" class="follow-btn"></a>
                    `;
                    snapsContainer.appendChild(snapElement);

                    const followBtn = snapElement.querySelector('.follow-btn');

                    if (favoritedSnaps && favoritedSnaps.includes(snap.cid)) {
                        followBtn.classList.add('active');
                    }
                });

                const totalPages = Math.ceil(data.total / itemsPerPage);
                  updatePaginationControls(page, totalPages);
            } catch (error) {
                console.error('Error fetching snaps:', error);
                hideLoader();
            }
        }

        function updatePaginationControls(page, totalPages) {
            paginationControls.innerHTML = '';

            const createButton = (text, pageNum, disabled = false, className = '') => {
                const button = document.createElement('button');
                button.disabled = disabled;

                className.split(' ').forEach(cls => button.classList.add(cls));

                button.classList.toggle('active', pageNum === page);
                button.addEventListener('click', () => renderPage(pageNum));
                return button;
            };

            if (page > 1) {
                const prevArrow = createButton('', page - 1, false, 'pagination-arrow prev');
                paginationControls.appendChild(prevArrow);
            }

            const startPage = Math.max(1, page - 1);
            const endPage = Math.min(totalPages, startPage + 2);

            for (let i = startPage; i <= endPage; i++) {
                const pageButton = createButton(i, i, false, 'pagination-button');
                pageButton.textContent = i;
                paginationControls.appendChild(pageButton);
            }

            if (page < totalPages) {
                const nextArrow = createButton('', page + 1, false, 'pagination-arrow next');
                paginationControls.appendChild(nextArrow);
            }
        }

        renderPage(currentPage);
    }
    if (window.location.href.includes('staff-snap/search')) {
        const sortButtons = document.querySelectorAll('.staff-snap__results-sort span');
        const resultsGrid = document.getElementById('results-grid');
        const menCheckbox = document.getElementById('men');
        const womenCheckbox = document.getElementById('women');
        const heightDropdown = document.getElementById('height-dropdown');
        const storeCheckboxes = document.querySelectorAll('.store-checkbox');
        const searchOptions = document.querySelectorAll('.staff-snap__search-option');
        const categoryCheckboxes = document.querySelectorAll('.category-checkbox');
        const activeTag = document.querySelector('.active-tag');
        const searchDrawerToggle = document.querySelector('.staff-snap__search-drawer-toggle');
        const searchDrawerContent = document.querySelector('.staff-snap__search-drawer-content');
        const storeCodes = {
            "20000001": "本部",
            "20028716": "原宿フラッグシップストア",
            "20031736": "新宿",
            "20028284": "ららぽーとTOKYO-BAY",
            "20023224": "東急スクエア横浜",
            "20025984": "ららぽーと湘南平塚",
            "20017222": "西武池袋",
            "20027977": "ららぽーと新三郷",
            "20027527": "ららぽーと富士見",
            "20028335": "アクアシティお台場",
            "20031669": "ダイバーシティ東京",
            "20031710": "ららぽーと横浜",
            "20027079": "大阪",
            "20031360": "神戸",
            "20030794": "LINKS UMEDA",
            "20031711": "ららぽーとエキスポシティ",
            "20030797": "あべのキューズモール",
            "20030795": "イオンモール堺北花田",
            "20030409": "イオンモール京都桂川",
            "20029115": "福岡天神",
            "20031546": "ららぽーと福岡",
            "20030793": "キャナルシティ博多",
            "20028717": "サンエー浦添パルコシティ",
            "20030791": "MOZOワンダーシティ",
            "20020795": "JR名古屋高島屋",
            "20027840": "ららぽーと名古屋みなとアクルス",
            "20030349": "ららぽーと愛知東郷",
            "20029114": "ららぽーと沼津",
            "20018196": "京都",
            "20018197": "なんばCITY",
            "20015102": "リーバイス・ファクトリーアウトレット 御殿場",
            "20031579": "リーバイス・ファクトリーアウトレット 北九州",
            "20033573": "ラゾーナ川崎",
            "20033577": "ららぽーと磐田",
            "20033572": "エミテラス所沢",
            "20033915": "イオンモール幕張新都心",
            "20034142": "名古屋 ZERO GATE",
            "20033888": "ららぽーと安城",
            "20034262": "イオンモール橿原",
            "20033831": "イオンモール広島府中",
            "20033861": "イオンモール浜松市野",
            "20034290":"イオンモール須坂",
            "20034671":"ららぽーと甲子園"
        };

        let fetchedData = [];
        let currentSort = 'pv';
        let currentGender = '';
        let currentHeightRange = '';
        let currentStore = '';
        let currentCategories = [];
        let currentTag = activeTag ? activeTag.textContent.trim() : '';
        let favoritedSnaps = [];
        let filterParams = {
            sort: 'pv',
            count: 40,
            offset: 0,
            current_page: 1,
            user_gender: '',
            height_range: '',
            shop_code: '',
            category: [],
            tag: `${activeTag ? activeTag.textContent.trim() : ''}`,
            from_height: '',
            to_height: '',
            categories: []
        };

        const savedFilters = localStorage.getItem('staffSnapFilters');
        if (savedFilters) {
            Object.assign(filterParams, JSON.parse(savedFilters));
            if (filterParams.user_gender === '1') {
                menCheckbox.checked = true;
            } else if (filterParams.user_gender === '2') {
                womenCheckbox.checked = true;
            }

            if (filterParams.from_height === '' && filterParams.to_height === '') {
                heightDropdown.value = 'none';
            } else if (filterParams.from_height === '' && filterParams.to_height === '149') {
                heightDropdown.value = '~149cm';
            } else if (filterParams.from_height === '185' && filterParams.to_height === '') {
                heightDropdown.value = '185cm~';
            } else {
                heightDropdown.value = `${filterParams.from_height}cm-${filterParams.to_height}cm`;
            }

            // storeCheckboxes.forEach(checkbox => {
            //     const storeName = Object.entries(storeCodes).find(([code]) => code === filterParams.shop_code)?.[1];
            //     checkbox.checked = checkbox.nextElementSibling.textContent.trim() === storeName;
            // });

            const selectedCodes = (filterParams.shop_code || '').split(',');
            storeCheckboxes.forEach(checkbox => {
                const storeName = checkbox.nextElementSibling.textContent.trim();

                const storeCode = Object.entries(storeCodes).find(
                    ([code, name]) => name === storeName
                )?.[0];

                checkbox.checked = selectedCodes.includes(storeCode);
            });

            categoryCheckboxes.forEach(checkbox => {
                checkbox.checked = filterParams.category.includes(checkbox.value);
            });
        }

        function buildQueryString(params) {
            const currentPage = params.current_page || 1
            const perPage = params.count || 40
            params['offset'] = (currentPage - 1) * perPage;
            localStorage.setItem('staffSnapFilters', JSON.stringify(params));
            const query = Object.entries(params)
                .filter(([key, value]) => value !== undefined && value !== null && value !== '' && (!Array.isArray(value) || value.length > 0))
                .map(([key, value]) => {
                    if (Array.isArray(value)) {
                        return `${key}=${value.join(',')}`;
                    }
                    return `${key}=${value}`;
                })
                .join('&');
            return query;
        }

        function renderPaginationControls(totalPages) {
            let paginationContainer = document.getElementById('pagination-controls');

            if (!paginationContainer) {
                paginationContainer = document.createElement('div');
                paginationContainer.id = 'pagination-controls';
                paginationContainer.classList.add('pagination-container');
                const parentContainer = document.querySelector('.staff-snap__results');
                if (parentContainer) {
                    parentContainer.appendChild(paginationContainer);
                }
            }

            paginationContainer.innerHTML = '';

            const currentPage = filterParams.current_page;

            if (currentPage > 1) {
                const prevArrow = document.createElement('button');
                prevArrow.classList.add('pagination-arrow', 'prev');
                prevArrow.addEventListener('click', function () {
                    filterParams.current_page = currentPage - 1;
                    const queryString = buildQueryString(filterParams);
                    fetchAndRenderData(queryString);
                });
                paginationContainer.appendChild(prevArrow);
            }

            const startPage = Math.max(1, currentPage - 1);
            const endPage = Math.min(totalPages, startPage + 2);

            for (let i = startPage; i <= endPage; i++) {
                const pageButton = document.createElement('button');
                pageButton.textContent = i;
                pageButton.classList.add('pagination-button');
                if (i === currentPage) {
                    pageButton.classList.add('active');
                }
                pageButton.addEventListener('click', function () {
                    filterParams.current_page = i;
                    const queryString = buildQueryString(filterParams);
                    fetchAndRenderData(queryString);
                });
                paginationContainer.appendChild(pageButton);
            }

            if (currentPage < totalPages) {
                const nextArrow = document.createElement('button');
                nextArrow.classList.add('pagination-arrow', 'next');
                nextArrow.addEventListener('click', function () {
                    filterParams.current_page = currentPage + 1;
                    const queryString = buildQueryString(filterParams);
                    fetchAndRenderData(queryString);
                });
                paginationContainer.appendChild(nextArrow);
            }
        }

        async function fetchAndRenderData(sortParam) {
            try {
                showLoader()
                const response = await fetch(`${staffStartApiUrl}/v1/coordinate?merchant_id=${staffStartMerchantId}&${sortParam}`);
                const data = await response.json();
                hideLoader();
                window.scrollTo({top: 0, behavior: 'smooth'});
                fetchedData = data.item;

                const total = parseInt(data.total, 10);
                const count = parseInt(data.params.count, 10);
                const totalPages = Math.ceil(total / count);

                renderPaginationControls(totalPages);

                if (loggedIn) {
                    favoritedSnaps = JSON.parse(staffStartFavoritedSnaps);
                }
                renderData(fetchedData);
            } catch (error) {
                console.error('Error fetching data:', error);
                hideLoader();
               
                 //window.scrollTo({top: 0, behavior: 'smooth'});
            }
        }

        function renderData(items) {
            resultsGrid.innerHTML = '';
            items.forEach(item => {
                const card = document.createElement('div');
                card.className = `staff-snap__result-card`;

                let hasVideo = false;
                item.attachments.forEach(attachment => {
                    if (attachment.type === 'video') {
                        hasVideo = true;
                    }
                });

                card.innerHTML = `
                    <div class="staff-snap__result-image-container">
                        <a href="${appProxy}/staff-snap/details/${item.cid}" data-cid="${item.cid}">
                            ${hasVideo ? '<span class="video-icon"></span>' : ''}
                             <img src="${item.image_url}" alt="${item.shop_name} + ${item.user_name}">
                        </a>
                        <a href="#" data-cid="${item.cid}" class="follow-btn"></a>
                    </div>
                    <a href="${appProxy}/staff-snap/staff/${item.user_id}" data-cid="${item.cid}">
                        <div class="staff-snap__result-info">
                            <div>
                                <img src="${item.user_image_url}" alt="${item.user_name}">
                            </div>
                            <div class="staff-snap__result-details">
                                <div>${item.shop_name}</div>
                                <div>${item.user_name}</div>
                                <div>${item.user_height}cm</div>
                            </div>
                        </div>
                    </a>
                `;
                resultsGrid.appendChild(card);

                if (favoritedSnaps && favoritedSnaps.includes(item.cid)) {
                    const followBtn = card.querySelector('.follow-btn');
                    followBtn.classList.add('active');
                }
            });
        }

        resultsGrid.addEventListener('click', async function(event) {
            if (event.target.classList.contains('follow-btn')) {
                followButtonClick(event);
            }
        });

        sortButtons.forEach(button => {
            button.addEventListener('click', function() {
                sortButtons.forEach(btn => btn.classList.remove('sort-active'));
                this.classList.add('sort-active');
                currentSort = this.getAttribute('data-sort');
                filterParams.sort = currentSort;
                const queryString = buildQueryString(filterParams);
                fetchAndRenderData(queryString);
            });
        });

        menCheckbox.addEventListener('change', function () {
              if (this.checked && womenCheckbox.checked==false) {
               // womenCheckbox.checked = false;
                filterParams.user_gender = '1';
            } else if(!this.checked && womenCheckbox.checked==true){
                    filterParams.user_gender = '2';
            }
            else {
               // filterParams.user_gender = '';
                delete filterParams.user_gender;
            }
            
            filterParams.current_page = 1;
            const queryString = buildQueryString(filterParams);
            fetchAndRenderData(queryString);
        });

        womenCheckbox.addEventListener('change', function () {
           if (this.checked && menCheckbox.checked==false ) {
                
               // menCheckbox.checked = false;
                filterParams.user_gender = '2';
            } else if(!this.checked && menCheckbox.checked==true){
                    filterParams.user_gender = '1';
            }else {
                   delete filterParams.user_gender;
            }
            filterParams.current_page = 1;
            const queryString = buildQueryString(filterParams);
            fetchAndRenderData(queryString);
        });

        heightDropdown.addEventListener('change', function () {
            currentHeightRange = this.value;

            if (currentHeightRange === 'none') {
                filterParams.from_height = '';
                filterParams.to_height = '';
            } else if (currentHeightRange === '~149cm') {
                filterParams.from_height = '';
                filterParams.to_height = '149';
            } else if (currentHeightRange === '185cm~') {
                filterParams.from_height = '185';
                filterParams.to_height = '';
            } else {
                const [from, to] = currentHeightRange.split('-').map(h => h.replace('cm', '').trim());
                filterParams.from_height = from;
                filterParams.to_height = to;
            }

            filterParams.current_page = 1;
            const queryString = buildQueryString(filterParams);
            fetchAndRenderData(queryString);
        });

        storeCheckboxes.forEach(checkbox => {
            checkbox.parentElement.addEventListener('click', function (event) {
                event.preventDefault();
                // storeCheckboxes.forEach(cb => {
                //     if (cb !== checkbox) {
                //         cb.checked = false;
                //     }
                // });
                checkbox.checked = !checkbox.checked;
               
               // currentStore = checkbox.checked ? checkbox.nextElementSibling.textContent.trim() : '';
               // const storeCode = Object.entries(storeCodes).find(([code, name]) => name === currentStore)?.[0] || '';
                //filterParams.shop_code = storeCode;

                   // Get all checked stores
                    const checkedStores = Array.from(storeCheckboxes)
                        .filter(cb => cb.checked)
                        .map(cb => cb.nextElementSibling.textContent.trim());
                    
                    // Convert store names to store codes
                    const storeCodesArray = checkedStores
                        .map(storeName =>
                            Object.entries(storeCodes).find(
                                ([code, name]) => name === storeName
                            )?.[0]
                        )
                        .filter(Boolean); // remove undefined values

                    // Set comma-separated store codes
                    filterParams.shop_code = storeCodesArray.join(',');



                filterParams.current_page = 1;
                const queryString = buildQueryString(filterParams);
                fetchAndRenderData(queryString);
            });
        });

        categoryCheckboxes.forEach(checkbox => {
            checkbox.addEventListener('change', function() {
                if (this.checked) {
                    currentCategories.push(this.value);
                } else {
                    currentCategories = currentCategories.filter(category => category !== this.value);
                }
                filterParams.categories = currentCategories;
                filterParams.current_page = 1;
                const queryString = buildQueryString(filterParams);
                fetchAndRenderData(queryString);
            });
        });

        if (activeTag) {
            activeTag.addEventListener('click', function() {
                filterParams.tag = ''
                activeTag.remove();
                const queryString = buildQueryString(filterParams);
                fetchAndRenderData(queryString);
            });
        }

        searchOptions.forEach(option => {
            const minusIcon = option.querySelector('.minus-icon');
            const plusIcon = option.querySelector('.plus-icon');
            const ul = option.querySelector('ul');
            const subOptions = option.querySelector('.staff-snap__search-options');
            const dropdown = option.querySelector('.dropdown');

            minusIcon.addEventListener('click', function() {
                if (subOptions) {
                    slideUp(subOptions);
                } else if (ul) {
                    slideUp(ul);
                } else if (dropdown) {
                    slideUp(dropdown);
                }
                option.classList.add('collapsed');
            });

            plusIcon.addEventListener('click', function() {
                if (subOptions) {
                    slideDown(subOptions);
                } else if (ul) {
                    slideDown(ul);
                } else if (dropdown) {
                    slideDown(dropdown);
                }
                option.classList.remove('collapsed');
            });
        });

        function slideUp(element) {
            element.style.transition = 'height 0.3s ease-out, padding 0.3s ease-out';
            element.style.height = element.scrollHeight + 'px';
            requestAnimationFrame(() => {
                element.style.height = '0';
                element.style.padding = '0';
                element.style.overflow = 'hidden';
            });
        }

        function slideDown(element) {
            element.style.transition = 'none';
            element.style.height = '0';
            element.style.padding = '0';
            element.style.overflow = 'hidden';
            requestAnimationFrame(() => {
                element.style.transition = 'height 0.3s ease-out, padding 0.3s ease-out';
                element.style.height = element.scrollHeight + 'px';
                element.style.padding = '0.5em 0';
            });
            element.addEventListener('transitionend', function handler() {
                element.style.height = 'auto';
                element.style.overflow = 'visible';
                element.removeEventListener('transitionend', handler);
            });
        }

        searchDrawerToggle.addEventListener('click', function() {
            searchDrawerContent.classList.toggle('open');
            searchDrawerToggle.textContent = searchDrawerContent.classList.contains('open') ? '▲' : '▼';
            document.body.style.overflow = searchDrawerContent.classList.contains('open') ? 'hidden' : '';
        });

        window.addEventListener('resize', function() {
            if (window.innerWidth > 767) {
                document.body.style.overflow = '';
                searchDrawerContent.classList.remove('open');
                searchDrawerToggle.textContent = '▼';
            }
        });

        fetchAndRenderData(buildQueryString(filterParams));
    }
    if (window.location.href.includes('staff-snap/details/')) {
        document.querySelector('.staff-snap__details h1').textContent = 'SNAP詳細';
        const thumbnails = document.querySelectorAll('.staff-snap__details-thumbnails img');
        const mainContent = document.getElementById('main-content');
        const imgContainer = document.getElementsByClassName('staff-snap__details-image')[0];
        const comment = document.querySelector('.staff-snap__details-comment p');
        const toggleButton = document.querySelector('.staff-snap__details-comment .toggle-button');
        const commentContainer = document.querySelector('.staff-snap__details-comment');
        const staffId = document.getElementById('staff-id').dataset.staffId;

        function updateMainContentHeight() {
            const aspectRatio = 3 / 4;
            const width = imgContainer.clientWidth;
            const height = width / aspectRatio;
            imgContainer.style.height = `${height}px`;
        }

        window.addEventListener('resize', updateMainContentHeight);
        updateMainContentHeight();

        thumbnails.forEach(thumbnail => {
            thumbnail.addEventListener('click', function() {
                const type = this.getAttribute('data-type');
                const orgUrl = this.getAttribute('data-org');
                const videoHtml = this.getAttribute('data-video');
                const datattr = this.getAttribute('alt');

                if (type === 'image') {
                    mainContent.innerHTML = `<img id="main-image" src="${orgUrl}" alt="${datattr}">`;
                } else if (type === 'video') {
                    mainContent.innerHTML = videoHtml;
                    const iframe = mainContent.querySelector('iframe');
                    iframe.style.width = '100%';
                    iframe.style.height = '100%';
                    iframe.style.objectFit = 'contain';
                }

                thumbnails.forEach(thumb => thumb.classList.remove('active'));
                this.classList.add('active');
            });
        });

        if (thumbnails.length > 0) {
            thumbnails[0].classList.add('active');
        }

        function updateToggleButton() {
            if (comment.scrollHeight > comment.clientHeight) {
                toggleButton.style.display = 'block';
            } else {
                toggleButton.style.display = 'none';
            }
        }

        toggleButton.addEventListener('click', function() {
            const isExpanded = commentContainer.classList.toggle('expanded');
            toggleButton.textContent = isExpanded ? '閉じる' : 'もっと見る';
        });

        updateToggleButton();

        document.body.addEventListener('click', async function(event) {
            if (event.target.classList.contains('follow-btn')) {
                followButtonClick(event);
            } else if (event.target.classList.contains('follow-icon') || event.target.classList.contains('follow-text')) {
                event.preventDefault();
                heartBeadAnimation(event.target);
                try {
                    const response = await fetch(isFollowing ? `${appProxy}/staff-start/api/follow-staffs/${staffId}` : `${appProxy}/staff-start/api/follow-staffs`, {
                        method: isFollowing ? 'DELETE' : 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: isFollowing ? null : JSON.stringify({ staffId: staffId })
                    });
                    if (response.status === 401) {
                        window.location.href = '/account/login';
                        return;
                    }
                    const result = await response.json();
                    if (result.success) {
                        isFollowing = !isFollowing;
                        updateFollowButton();
                    }
                } catch (error) {
                    console.error('Error:', error);
                }
            }
        });

        document.querySelector('.left-arrow').addEventListener('click', function() {
            const activeThumbnail = document.querySelector('.staff-snap__details-thumbnails img.active');
            const prevThumbnail = activeThumbnail.previousElementSibling || thumbnails[thumbnails.length - 1];
            prevThumbnail.click();
        });

        document.querySelector('.right-arrow').addEventListener('click', function() {
            const activeThumbnail = document.querySelector('.staff-snap__details-thumbnails img.active');
            const nextThumbnail = activeThumbnail.nextElementSibling || thumbnails[0];
            nextThumbnail.click();
        });

        if (loggedIn) {
            fetchFavorites();
            fetchFollowStatus(staffId);
        }
    }
});
